import { render, staticRenderFns } from "./LabelRoute.vue?vue&type=template&id=7fb8fd7d&lang=html&"
import script from "./LabelRoute.vue?vue&type=script&lang=js&"
export * from "./LabelRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports